import { render, staticRenderFns } from "./BaseBodyDialog.vue?vue&type=template&id=6d4cf30e"
import script from "./BaseBodyDialog.vue?vue&type=script&lang=js"
export * from "./BaseBodyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports